import { z } from 'zod';
import { defineEndpoint } from '../define';

export const SAMPLE_RANGES = ['1h', '24h', '7d'] as const;
export const SampleRangeSchema = z.enum(SAMPLE_RANGES);
export type SampleRange = z.infer<typeof SampleRangeSchema>;

/** `range` for the preset charts, or `from`+`to` for a job's own window. */
export const MachineSamplesQuerySchema = z
  .object({
    range: SampleRangeSchema.optional(),
    from: z.string().datetime().optional(),
    to: z.string().datetime().optional(),
  })
  .refine((q) => q.range !== undefined || (q.from !== undefined && q.to !== undefined), {
    message: 'Pass range, or both from and to',
  })
  .refine((q) => !q.from || !q.to || Date.parse(q.from) < Date.parse(q.to), {
    message: 'from must be before to',
    path: ['from'],
  });

export const SamplePointSchema = z.object({
  ts: z.string().datetime(),
  cpuPct: z.number(),
  memUsedBytes: z.number(),
  memTotalBytes: z.number(),
  swapUsedBytes: z.number(),
  swapTotalBytes: z.number(),
  diskReadBps: z.number(),
  diskWriteBps: z.number(),
  netRxBps: z.number(),
  netTxBps: z.number(),
});
export type SamplePoint = z.infer<typeof SamplePointSchema>;

export const getRunnerMachineSamples = defineEndpoint({
  method: 'GET',
  path: '/v1/runner-monitor/machines/:machineId/samples',
  params: z.object({ machineId: z.string().uuid() }),
  query: MachineSamplesQuerySchema,
  body: z.undefined(),
  response: z.object({
    data: z.array(SamplePointSchema),
    /** 0 = raw 15s samples; otherwise each point averages this many seconds. */
    meta: z.object({ bucketSeconds: z.number().int(), from: z.string(), to: z.string() }),
  }),
});
